import * as React from "react";

import './Price.scss';

export const EcommProductPrice = ({ price, compare_at_price = 0, show_discount = false }) => {

    const isOnSale = price < compare_at_price;
    let percentageDiscount;

    if (compare_at_price > 0) {
        percentageDiscount = calculateDiscountPercentage(compare_at_price, price);
    }

    function calculateDiscountPercentage(originalPrice, salePrice) {
        if (originalPrice <= 0 || salePrice <= 0 || salePrice >= originalPrice) {
            console.error("Invalid prices. Ensure originalPrice > salePrice and both are > 0.");
            return 0; // Return 0 to indicate no discount or invalid input
        }
        const discountPercentage = ((originalPrice - salePrice) / originalPrice) * 100;
        return discountPercentage.toFixed(2); // Rounds the result to 2 decimal places and returns it as a string
    }

    return (
        <div className="product__price" data-prodify-price-container="" x-data="{ is_sale: true }">
            {isOnSale ? (
                <>
                    <span className="sr-only">Special Price</span>
                    <div className="product__sale-price">{price}</div>
                    <span className="line-through">{compare_at_price}</span>
                    {show_discount && percentageDiscount && (
                        <div className="product__discount_percent">
                            Save {percentageDiscount}%
                        </div>
                    )}
                </>
            ) : (
                <>
                    <span className="sr-only">Regular Price</span>
                    <div className="product__price">{price}</div>
                </>
            )}
        </div>
    );
};
